import axios from "axios";

export const AxiosInstance = axios.create({
  // baseURL: "http://127.0.0.1:8000/api/",
  // baseURL: "https://devback.buyforme.ru/api/",
  baseURL: "https://back.buyforme.ru/api",
});
AxiosInstance.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem("token");
    if (authToken) {
      config.headers.authorization = `Bearer ${authToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);
